var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"del-btn-cover",attrs:{"variant":"outline-secondary"},on:{"click":function($event){return _vm.$emit('btnClick')}}},[_c('i',{staticClass:"fa-solid fa-minus del-icon"})])
}
var staticRenderFns = []

export { render, staticRenderFns }